import React from 'react';
import SubscriberItem from '@/components/molecules/SubscriberItem';

interface Subscriber {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

interface SubscriberListProps {
  items: Subscriber[];
  onChangeSubscription: (id: string) => void;
  onSuspend: (id: string) => void;
  onItemClick: (id: string) => void;
  onUnregister?: (id: string) => void;
}

const SubscriberList: React.FC<SubscriberListProps> = ({
  items,
  onChangeSubscription,
  onSuspend,
  onItemClick,
  onUnregister
}) => {
  console.log('items', items);
  return (
    <div className="flex-1 w-full space-y-3 pb-8 md:pb-0">
      {items?.map((item: any) => (
        <SubscriberItem
          key={item.id}
          item={item}
          onChangeSubscription={onChangeSubscription}
          onSuspend={onSuspend}
          onItemClick={onItemClick}
          onUnregister={onUnregister}
        />
      ))}
    </div>
  );
};

export default SubscriberList;
